"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSDBTable = void 0;
var TSDBTable;
(function (TSDBTable) {
    TSDBTable["temperatureK"] = "temperatureK";
    TSDBTable["relativeHumidity"] = "relativeHumidity";
    TSDBTable["carbonDioxide"] = "carbonDioxide";
    TSDBTable["illuminance"] = "illuminance";
    TSDBTable["soundPressureLevel"] = "soundPressureLevel";
    TSDBTable["volatileOrganicCompound"] = "volatileOrganicCompound";
    TSDBTable["assetUtilization"] = "assetUtilization";
    TSDBTable["pressure"] = "pressure";
    TSDBTable["unitState"] = "unitState";
    TSDBTable["counter"] = "counter";
})(TSDBTable = exports.TSDBTable || (exports.TSDBTable = {}));
//# sourceMappingURL=tsdb.js.map